function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { StyleSheet, LayoutAnimation } from 'react-native';
import * as R from 'unitx/ramda';
import { FlatList, Card, View, Text } from "../../../native";
import Collapsible from "../../../Collapsible";
import Icon from "../../../Icon";
import { isMultiSelect, getDefaultRegistry } from "../../utils";
import { useFormContext } from "../FormContext";
import AddButton from "../AddButton";

function ArrayFieldTemplate(props) {
  const defaultRegistery = getDefaultRegistry();
  const {
    schema,
    registry = defaultRegistery
  } = props;

  const overridedRegistery = _objectSpread(_objectSpread({}, defaultRegistery), registry);

  return R.ifElse(() => isMultiSelect(schema, overridedRegistery.rootSchema), () => /*#__PURE__*/React.createElement(DefaultFixedArrayFieldTemplate, props), () => /*#__PURE__*/React.createElement(DefaultNormalArrayFieldTemplate, props))();
}

// Used in the two templates
const DefaultArrayItem = props => {
  const {
    children,
    index,
    onReorderClick,
    onDropIndexClick,
    hasMoveUp = true,
    hasMoveDown = true,
    hasRemove = true,
    disabled,
    readonly,
    formContext
  } = props;
  const {
    mapping
  } = useFormContext(formContext);
  return /*#__PURE__*/React.createElement(Card, {
    key: index,
    style: {
      marginBottom: 10
    }
  }, /*#__PURE__*/React.createElement(Text, null, `[${index}]`), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
    style: styles.actionRow
  }, hasMoveUp &&
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(Icon, _extends({}, mapping.upIcon, {
    onPress: () => R.pipe(() => LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut), () => onReorderClick === null || onReorderClick === void 0 ? void 0 : onReorderClick(index, index - 1)())('')
  })), hasMoveDown &&
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(Icon, _extends({}, mapping.downIcon, {
    onPress: () => onReorderClick === null || onReorderClick === void 0 ? void 0 : onReorderClick(index, index + 1)()
  })), hasRemove &&
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(Icon, _extends({
    disabled: disabled || readonly
  }, mapping.deleteIcon, {
    onPress: () => R.pipe(() => LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut), () => onDropIndexClick === null || onDropIndexClick === void 0 ? void 0 : onDropIndexClick(index)())('')
  }))), /*#__PURE__*/React.createElement(View, {
    style: styles.card
  }, children)));
};

const DefaultNormalArrayFieldTemplate = ({
  idSchema,
  uiSchema,
  schema,
  items,
  canAdd,
  disabled,
  readonly,
  onAddClick,
  formContext,
  DescriptionField
}) => {
  var _uiSchema$uiDescript, _uiSchema$uiDescript2;

  // const items = R.isEmptyArray(defaultItems ?? [])
  //   ? getDefaultFormState(schema)
  //   : defaultItems
  const {
    mapping
  } = useFormContext(formContext);
  const [state] = React.useState({
    collapsed: false,
    listKey: R.uuid()
  });
  return /*#__PURE__*/React.createElement(View, _extends({}, mapping.fieldContainer, {
    style: [mapping.fieldContainer.style]
  }), ((_uiSchema$uiDescript = uiSchema['ui:description']) !== null && _uiSchema$uiDescript !== void 0 ? _uiSchema$uiDescript : schema.description) && /*#__PURE__*/React.createElement(DescriptionField, {
    description: (_uiSchema$uiDescript2 = uiSchema['ui:description']) !== null && _uiSchema$uiDescript2 !== void 0 ? _uiSchema$uiDescript2 : schema.description // @ts-ignore
    ,
    formContext: formContext,
    key: `array-field-description-${idSchema.$id}`,
    idSchema: idSchema,
    descriptionOptions: mapping.arrayDescription
  }), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Collapsible, {
    collapsed: state.collapsed
  }, /*#__PURE__*/React.createElement(FlatList, {
    key: `array-field-list-${idSchema.$id}1`,
    listKey: state.listKey,
    style: styles.content,
    data: items,
    renderItem: ({
      item
    }) => /*#__PURE__*/React.createElement(DefaultArrayItem, _extends({
      formContext: formContext
    }, item)),
    keyExtractor: (item, index) => `list-${idSchema.$id}-${index}`
  }), canAdd && /*#__PURE__*/React.createElement(AddButton, {
    disabled: disabled || readonly,
    onPress: onAddClick
  }))));
};

const DefaultFixedArrayFieldTemplate = DefaultNormalArrayFieldTemplate;
const styles = StyleSheet.create({
  container: {// marginBottom: 15,
    // paddingBottom: 15,
    // paddingTop: 15,
  },
  content: {
    marginTop: 10
  },
  card: {
    marginTop: 10,
    paddingLeft: 5,
    paddingBottom: 20,
    borderRadius: 5
  },
  actionRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    right: 30,
    height: 24
  },
  actionButton: {
    width: 24,
    height: 24
  }
});
export default ArrayFieldTemplate;